import { render, staticRenderFns } from "./OrganizationInformationDisplay.vue?vue&type=template&id=045c87fd&scoped=true&"
import script from "./OrganizationInformationDisplay.vue?vue&type=script&lang=js&"
export * from "./OrganizationInformationDisplay.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationInformationDisplay.vue?vue&type=style&index=0&id=045c87fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c87fd",
  null
  
)

export default component.exports